import api from '../../plugins/api';

const generateLink = ({ url, name, typeId, documentId, userId, dealId, signType, step, adminSignature, sendSms, bankIds }) => {
  return api.post('/api/signature/generateLink', { url, name, typeId, documentId, userId, dealId, signType, step, adminSignature, sendSms, bankIds });
};

export default generateLink;
